module.exports = __webpack_public_path__ + "media/common/images/badges/gray/zkuseny_pruvodce-1a987472d25a99a84bc8504bae72c714.svg";